export default class LabResult {
    constructor(type, result, rawResult, resultStatus, mnemonic, collectionDate, resultDate, collectionSite, resultId, labName, labAddressStreet, labAddressCity, labAddressProv, labAddressPostalCode, labAddressCountry) {
        this.type = type;
        this.result = result;
        this.rawResult = rawResult;
        this.collectionDate = collectionDate;
        this.resultDate = resultDate;
        this.resultStatus = resultStatus;
        this.mnemonic = mnemonic;
        this.collectionSite = collectionSite;
        this.resultId = resultId;
        this.labName = labName || '';
        this.labAddressStreet = labAddressStreet || '';
        this.labAddressCity = labAddressCity || '';
        this.labAddressProv = labAddressProv || '';
        this.labAddressPostalCode = labAddressPostalCode || '';
        this.labAddressCountry = labAddressCountry || '';
    }
}
